angular.module('quattro.config', []);
angular.module('quattro.bmbo.config', [])
    .constant('account_type', 'BMBO')
    .constant('account_anrede', [
        {
            label: 'ACCOUNT.Herr',
            value: 'herr'
        },
        {
            label: 'ACCOUNT.Frau',
            value: 'frau'
        },
        {
            label: 'ACCOUNT.unknown',
            value: 'unknown'
        }
    ])
    .constant('mail_plan_list', [
        'light',
        'standard',
        'premium',
    ])
    .constant('mail_plan_list_new_pricing', [
        'light',
        'standard',
        'premium',
    ])
    .constant('mail_plan_list_new_pricing_add_quota', [
        'standard',
        'premium',
    ])
    .constant('bmbo_account_plans', [
        {
            label: 'basic',
            value: 'basic'
        },
        {
            label: 'profi',
            value: 'profi'
        },
        {
            label: 'profixl',
            value: 'profixl'
        },
        {
            label: 'reseller',
            value: 'reseller'
        },
    ]);
